import { Store } from "../classes/Store";
import { setUrlFromState } from "./setUrlFromState";
import { startSearch } from "./startSearch";

export function enablePagination(store: Store) {
  [
    ...(document.getElementsByClassName(
      "page-link"
    ) as HTMLCollectionOf<HTMLButtonElement>),
  ].map((button) => {
    button.addEventListener("click", () => {
      store.updateState(
        "_page",
        parseInt(button.dataset["page"] || "0") || undefined
      );
      setUrlFromState(store.getState());
      startSearch(store);
    });
  });
}
